import { LineIcon } from "@/svg/survey/line-icon";
import { SurveyRangeInput } from "@/components/common/resource-survey/components/survey-form/components/survey-question/presets/survey-range";
import { useContext } from "react";
import { SurveyFormContext } from "@/components/common/resource-survey/components/survey-form/survey-form-context";
import { defaultSurveyRangeTooltip } from "@/components/common/resource-survey/components/survey-form/components/survey-question/presets/data";

export const SurveyRangeList = ({
  index,
  payload,
}: {
  index: number;
  payload: SurveyNodePayloadRangeListVM;
}) => {
  const { setStepsAnswers, stepsAnswers, currentStep } =
    useContext(SurveyFormContext);

  const stepAnswers = stepsAnswers[currentStep];
  const { list } = stepAnswers[index] as { list: { value: null | number } };

  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  return (
    <div>
      {payload.list.map(({ max, min, step, label }, subIndex) => {
        const tooltipMap =
          min === 1 && max === 5 && step === 1
            ? defaultSurveyRangeTooltip
            : false;
        const listItem = list[subIndex];
        const steps = [];
        for (let i = min; i <= max; i += step) {
          steps.push(i);
        }

        return (
          <div key={label}>
            <div className={"mb-4 flex items-center gap-2"}>
              <div className={"w-4 font-semibold"}>{alphabet[subIndex]}.</div>
              <LineIcon />
              <div className={"text-base leading-6 font-normal text-zinc-800"}>
                {label}
              </div>
            </div>
            <SurveyRangeInput
              value={listItem.value}
              tooltipMap={tooltipMap}
              steps={steps}
              handleStepClick={(stepValue) => {
                setStepsAnswers((draft) => {
                  draft[currentStep][index].list[subIndex].value = stepValue;
                });
              }}
            />
          </div>
        );
      })}
    </div>
  );
};
